import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

function MyDropzone({
  type,
  uploadFile,
  disabledPlaceHolder = false,
  clearDropZone = false,
}) {
  const [files, setFiles] = useState([]);

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      disabled: disabledPlaceHolder,

      accept:
        ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.mp4,.mkv,.wav,.omv",

      multiple: false,

      onDrop: (acceptedFiles) => {
        if (!acceptedFiles.length) return;

        const selectedFiles = acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        );

        setFiles(selectedFiles);

        acceptedFiles.forEach((file) => {
          uploadFile(file);
        });
      },
    });

  useEffect(() => {
    if (clearDropZone) {
      setFiles([]);
    }
  }, [clearDropZone]);

  useEffect(() => {
    return () => {
      files.forEach((file) => {
        if (file.preview) {
          URL.revokeObjectURL(file.preview);
        }
      });
    };
  }, [files]);

  return (
    <section
      style={{
        width: "100%",
      }}
    >
      <div
        {...getRootProps({
          className: "dropzone",
        })}
        style={{
          border: "1.5px dashed #d6c7b2",
          borderRadius: 12,
          padding: "24px 16px",
          background: "#fffcf7",
          textAlign: "center",
          cursor: disabledPlaceHolder ? "not-allowed" : "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          transition: "border-color .2s, background .2s",
        }}
      >
        <input {...getInputProps()} />

        <div
          style={{
            marginBottom: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#F56620"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
            <line x1="5" y1="21" x2="19" y2="21" />
          </svg>
        </div>

        <div
          style={{
            fontSize: 13.5,
            color: "#475569",
            fontWeight: 500,
            marginBottom: 4,
          }}
        >
          Drag & drop a file here, or{" "}
          <span
            style={{
              color: "#F56620",
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            browse
          </span>
        </div>

        <div
          style={{
            fontSize: 12,
            color: "#94a3b8",
          }}
        >
          PDF, Word, Excel, PNG or JPG
        </div>
      </div>

      {acceptedFiles.length > 0 && (
        <div
          style={{
            marginTop: 12,
            padding: "10px 14px",
            background: "#f8fafc",
            borderRadius: 8,
            border: "1px solid #e2e8f0",
          }}
        >
          <div
            style={{
              fontSize: 12,
              color: "#334155",
              fontWeight: 600,
            }}
          >
            Uploaded File:
            <ul
              style={{
                margin: "4px 0 0",
                paddingLeft: 18,
                color: "#2563eb",
              }}
            >
              {acceptedFiles.map((file) => (
                <li key={`${file.name}-${file.lastModified}`}>{file.name}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {fileRejections.length > 0 && (
        <div
          style={{
            marginTop: 8,
            color: "#ef4444",
            fontSize: 12,
          }}
        >
          {fileRejections.map(({ file, errors }) => (
            <div key={`${file.name}-${file.lastModified}`}>
              <strong>{file.name}</strong>

              {errors.map((error) => (
                <div key={error.code}>{error.message}</div>
              ))}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default MyDropzone;
